

import  { instance  } from "../api";

const fetchUserData = (setUserAttributes) => {
 
      instance.get("/api/utilisateurs/connected")
      .then((result)=>  { setUserAttributes(result.data)
        console.log('result.data', result.data)
     })    
              
    .catch ((error) =>{console.log('error', error)
      
    })
};

export default fetchUserData;

export const getUserByEmail=(setUserAttributes, email)=>{
  instance.get(`/api/utilisateurs/${email}`)
  .then((result)=>  { setUserAttributes(result.data)
      
     })
}
export const verifToken=async(utilisateurId, token)=>{
 try 
 { 
  const response = await instance.get(`/api/utilisateurs/${utilisateurId}/verifier/${token}`)
  
    return response
}
 catch(error ) {
    throw new Error(`Erreur lors de la vérification du jeton : ${error.response?.status || error.message}`);
  };
 
}

export const CreateNewUser=(data)=>{
 return instance.post(`/api/utilisateurs/enregistrement`, data)
}
export const oubli=async(data)=>{
  try 
  { 
    const response =  await instance.post(`/api/utilisateurs/demande-reinitialisation-mot-de-passe`, data);
   
     return response
 }
  catch(error ) {
     throw new Error(`Erreur lors de la vérification du jeton : ${error.response?.status || error.message}`);
   };
  
 }
export const ResetPassword=async(formData)=>{
  try 
  { 
    const response = await instance.post(`/api/utilisateurs/reinitialisation-mot-de-passe`, formData );
   
     return response
 }
  catch(error ) {
     throw new Error(`Erreur lors de la réinitialisation de mot de passe : ${error.response?.status || error.message}`);
   };
  
 }
export const getUsersByClient=(setUserList ,clientId)=>{

  instance.get(`api/utilisateurs/client/${clientId}`)
   .then((result)=>  { setUserList(result.data)        
   }) 
 }
export const getUserByClient=(setUserList)=>{

  instance.get("api/utilisateurs/clients/admin")
   .then((result)=>  { setUserList(result.data)        
   }) 
 }
 export const InviteUser=async(data)=>{
  try 
  { 
const response =await instance.post(`/api/utilisateurs/invitation`, data)

return response
  } 
  catch(error ) {
    throw new Error(`Erreur lors de l'invitation  : ${error.response?.status || error.message}`);
  };
 }
 export const DeleteUserByContact=async (selectedUser , setSelectedUser)=>{
  try 
  { 
    const response = await instance.delete(`/api/utilisateurs/delete/${selectedUser}`);
    // setSelectedUser(null); // Exemple de mise à jour de l'état après la suppression
    if (response.status === 200 || response.status === 204) {
      setSelectedUser(null);
    }
    return response


  } 
  catch(error ) {
    throw new Error(`Erreur lors de l'invitation  : ${error.response?.status || error.message}`);
  };
 }